module.exports = __webpack_public_path__ + "static/reversity_terms_of_service-3b9b4328653370999ae923df69632949.pdf";